import { classNames } from "../utils/formatters";

export default function EquipmentBadge({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  return (
    <span
      className={classNames(
        "inline-flex items-center rounded-full bg-orange-100 py-0.5 pl-2.5 pr-1 text-sm font-medium text-orange-600",
        className
      )}
    >
      {text}
      <button
        type="button"
        className="ml-0.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-orange-400 hover:bg-orange-200 hover:text-orange-500 focus:bg-orange-500 focus:text-white focus:outline-none"
      >
        <span className="sr-only">Remove equipment</span>
        <svg
          className="h-2 w-2"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 8 8"
        >
          <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
        </svg>
      </button>
    </span>
  );
}
